import React from 'react';
import {QuerySyntaxRuleItem} from '../content/types';
import QueryCopyButton from './QueryCopyButton';

interface Props {
    rule: QuerySyntaxRuleItem;
}

const QuerySyntaxRule = React.memo<Props>(({rule}) => (
    <article className="query-help-modal__syntax-rule">
        <div className="query-help-modal__sample-card-header">
            <h4 className="query-help-modal__sample-card-title">
                <strong className="query-help-modal__syntax-rule-prefix">{rule.operator}</strong>
                <span className="query-help-modal__syntax-rule-text">{rule.description}</span>
            </h4>
            {rule.example ? <QueryCopyButton query={rule.example} /> : null}
        </div>

        {rule.example ? (
            <pre className="query-help-modal__query-block">{rule.example}</pre>
        ) : null}

    </article>
));

export default QuerySyntaxRule;
